import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const VyhledaniPage = lazy(() =>
  import('@/modules/servis/VyhledaniPage').then((m) => ({ default: m.VyhledaniPage })),
);

interface VyhledaniSearch {
  zakaznik?: string;
  vozidlo?: string;
  spz?: string;
  ukon?: string;
}

function parseVyhledaniSearch(input: Record<string, unknown>): VyhledaniSearch {
  const out: VyhledaniSearch = {};
  for (const key of ['zakaznik', 'vozidlo', 'spz', 'ukon'] as const) {
    const value = input[key];
    if (typeof value === 'string' && value.trim() !== '') {
      out[key] = value;
    }
  }
  return out;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/servis/vyhledani',
  component: () => (
    <Suspense fallback={null}>
      <VyhledaniPage />
    </Suspense>
  ),
  validateSearch: parseVyhledaniSearch,
});
